import { ReactElement } from 'react';
import styled from 'styled-components';
import { colors } from '@theme/lib';

export type StatusBadgeVariant = 'green' | 'orange' | 'red';

const variantStyles: Record<StatusBadgeVariant, { bg: string; border: string; color: string }> = {
  green: { bg: colors.parakeet, border: colors.seagrass, color: colors.zooFont },
  orange: { bg: colors.honeyBee, border: colors.tiger, color: colors.zooFont },
  red: { bg: colors.redPanda, border: colors.tiger, color: colors.white },
};

const StyledStatusBadge = styled.div<{ $variant: StatusBadgeVariant }>`
  display: inline-block;

  color: ${({ $variant }) => variantStyles[$variant].color};

  font-family: ${(props) => props.theme.fonts.button};
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;

  background-color: ${({ $variant }) => variantStyles[$variant].bg};
  border: 2px solid ${({ $variant }) => variantStyles[$variant].border};
  border-radius: 12px;

  padding: 0.625rem 0.875rem 0.5rem 0.875rem;
`;

export type Props = {
  label: string;
  variant?: StatusBadgeVariant;
  className?: string;
};

export default function StatusBadge({ label, variant = 'green', className }: Props): ReactElement {
  return (
    <StyledStatusBadge $variant={variant} className={className} aria-hidden="true">
      {label}
    </StyledStatusBadge>
  );
}
